<h2 mat-dialog-title class="dialog-header">
  <div class="dialog-header-copy">
    <span>Sender SMS</span>
    <p>Detalle del SMS enviado y su información operativa.</p>
  </div>
  <button mat-icon-button aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <section class="sender-summary-card">
    <div class="sender-summary-grid">
      <div class="summary-item">
        <span class="summary-label">ID</span>
        <strong>#{{ sender.id }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-label">Estado</span>
        <span class="status-pill" [class.status-pill--sent]="sender.sent" [class.status-pill--pending]="!sender.sent">
          {{ sender.sent ? 'Enviado' : 'Pendiente' }}
        </span>
      </div>
      <div class="summary-item">
        <span class="summary-label">Intentos</span>
        <strong>{{ sender.attempts || 0 }}</strong>
      </div>
      <div class="summary-item">
        <span class="summary-label">Template</span>
        <strong>{{ sender.template || 'Sin template' }}</strong>
      </div>
    </div>
  </section>

  <div class="read-grid two-columns sender-form-grid">
    <div class="read-item">
      <span class="read-label">From</span>
      <div class="read-value">{{ sender.from || '—' }}</div>
    </div>

    <div class="read-item">
      <span class="read-label">To</span>
      <div class="read-value">{{ sender.to || '—' }}</div>
    </div>

    <div class="read-item full-span">
      <span class="read-label">Body</span>
      <pre class="read-block">{{ sender.body || '—' }}</pre>
    </div>

    <div class="read-item full-span">
      <span class="read-label">Data</span>
      <pre class="read-block">{{ sender.data || '—' }}</pre>
    </div>

    <div class="read-item">
      <span class="read-label">Delivery Time</span>
      <div class="read-value">{{ sender.deliveryTime ? (sender.deliveryTime | date: appService.FORMAT_DATETIME) : '—' }}</div>
    </div>

    <div class="read-item">
      <span class="read-label">Created At</span>
      <div class="read-value">{{ sender.createdAt ? (sender.createdAt | date: appService.FORMAT_DATETIME) : '—' }}</div>
    </div>

    <div class="read-item full-span">
      <span class="read-label">Updated At</span>
      <div class="read-value">{{ sender.updatedAt ? (sender.updatedAt | date: appService.FORMAT_DATETIME) : '—' }}</div>
    </div>
  </div>
</mat-dialog-content>
